(function () {
  'use strict';
  angular.module('vcexamtemplate')
    .component('examtemplatenew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="examtemplatenew-component" data-hook="examtemplatenew-component">
        <h3>Neue Untersuchungs-/Befundvorlage anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addExamtemplate()" ng-hide="vm.newexamtemplate">Neue Untersuchungs-/Befundvorlage anlegen</div>
        <div ng-show="vm.newexamtemplate">
          <examtemplateform examtemplate="vm.newexamtemplate" parentsave="vm.saveNewExamtemplate(examtemplate)" oncancel="vm.cancel()"></examtemplateform>
        </div>
        <div class="spacer-top"></div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Untersuchungs-/Befundvorlage erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Untersuchungs-/Befundvorlage wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Untersuchungs-/Befundvorlage konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Examtemplate', 'Rlog',
        function ($log, Examtemplate, Rlog) {
          let vm = this;
          vm.addExamtemplate = addExamtemplate;
          vm.saveNewExamtemplate = saveNewExamtemplate;
          vm.cancel = cancel;
          
          function addExamtemplate() {
            vm.newexamtemplate = {
              template: {
                includefindings: false,
                loadfiles: false,
                layout: 'col'}
            };
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewExamtemplate(examtemplate) {
            $log.debug('debug: create new examtemplate: ', examtemplate);
            delete vm.newexamtemplate;
            Examtemplate.$create(examtemplate).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new examtemplate failed: ', err);
              Rlog.error('vcutils.examtemplate', 'examtemplatenew', 'Creation of new examtemplate failed: ', {error: err, examtemplate: vm.newexamtemplate});
            });
          }
          
          function cancel() {
            delete vm.newexamtemplate;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());